import React, { useEffect, useState } from 'react';
import { Input, Radio, RadioChangeEvent } from 'antd';
import { productType, initProductType } from '../../../model/master';

const { TextArea } = Input;

interface props {
    productType: productType,
    disabled?: boolean,
    onChange: (data: any) => void
}

const ProductTypeDetail: React.FC<props> = (prop) => {
    const [data, setData] = useState<productType>(initProductType);

    const onDataChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        let key: string = String(e.target.name);
        let value: any = e.target.value;
        let object: any = { ...data, [key]: value };
        setData(object);
        prop.onChange(object);
    };

    const onStatusChange = (e: RadioChangeEvent) => {
        let object: any = { ...data, status: e.target.value };
        setData(object);
        prop.onChange(object);
    };

    useEffect(() => {
        setData(prop.productType || initProductType);
    }, [prop.productType]);

    return (
        <div className='detailFormContainer'>
            <div className='formRow'>
                <div className='formGroup'>
                    <label className='formLabel required'>ชื่อประเภทสินค้า</label>
                    <Input 
                        name="name" 
                        placeholder="เช่น เครื่องดื่ม, เบเกอรี่, วัตถุดิบ, ของใช้" 
                        value={data.name} 
                        onChange={onDataChange} 
                        disabled={prop.disabled} 
                    />
                </div>
            </div>

            <div className='formRow'>
                <div className='formGroup'>
                    <label className='formLabel'>คำอธิบาย / หมายเหตุ</label>
                    <TextArea 
                        name="remark" 
                        rows={3} 
                        placeholder="ระบุรายละเอียดเพิ่มเติมเกี่ยวกับประเภทสินค้านี้..." 
                        value={data.remark} 
                        onChange={onDataChange} 
                        disabled={prop.disabled} 
                    />
                </div>
            </div>

            <div className='formRow'>
                <div className='formGroup'>
                    <label className='formLabel'>สถานะการใช้งาน</label>
                    <Radio.Group 
                        onChange={onStatusChange} 
                        value={data.status !== undefined ? data.status : 1}
                        disabled={prop.disabled}
                    >
                        <Radio value={1}>🟢 ใช้งานปกติ (Active)</Radio>
                        <Radio value={0}>⚪ ปิดการใช้งาน (Inactive)</Radio>
                    </Radio.Group>
                </div>
            </div>
        </div>
    );
};

export default ProductTypeDetail;
